import FaqCreate from './FaqCreate';

export default FaqCreate;
